import React from 'react';
import { Inline } from '@styleseat/ui';

type ServiceSectionHeaderProps = {
  children: React.ReactNode;
};

export const ServiceSectionHeader: React.FC<ServiceSectionHeaderProps> = ({
  children,
}) => (
  <Inline
    padding={4}
    paddingTop={12}
    paddingLeft={8}
    accessibilityRole="header"
  >
    {children}
  </Inline>
);
